export const UserRole = {
  MEMBER: 'member',
  ADMIN: 'admin',
};
